export const UAKDO_CONTROLLER_CONTROL_TEXT = {
  sectionStepLabel: '08',
  sectionTitle: 'Контроль УАКДО',
  sectionDescription: 'Перегляньте дані, заповнені відповідальним УАКДО.',
  loadingText: 'Завантаження даних контролю УАКДО...',
  confirmButton: 'Підтвердити',
  rejectButton: 'Відкликати',
  rejectCommentTitle: 'Коментар до відкликання',
  rejectCommentConfirmButton: 'Підтвердити',
  rejectCommentLoadingButton: 'Підтвердження...',
  confirmedMessage: 'Контроль УАКДО підтверджено. Заявку передано далі.',
  rejectedMessage: 'Заявку відкликано контролером УАКДО.',
  successCloseButton: 'Закрити',
  accessDeniedText: 'У вас немає доступу до кроку контролера УАКДО.',
} as const;
